var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-editor-block title"},[_c('el-input',{attrs:{"placeholder":"請輸入次標題"},on:{"input":_vm.onInput},model:{value:(_vm.mValue),callback:function ($$v) {_vm.mValue=$$v},expression:"mValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }